import React from "react";
import { Flex } from "../../../Flex";
import { Meter } from "../../../../types/Meter";
import { ErrorMessage, Field } from "formik";
import styled from "styled-components";
import { mediaQueries } from "../../../../theme";
import { FormikInputText } from "../../../FormikInputText";
import { Box } from "../../../Box";
import { Span } from "../../../Span";
import { IconPopupTip } from "../../../IconPopupTip";
import { FormInputErrorMessage } from "../../../FormInputErrorMessage";

interface Props {
  meters: Meter[];
  meterSerialOptional: boolean;
}

const MeterDividerLine = styled(Flex)`
  display: none;

  ${mediaQueries.largeDevice} {
    display: flex;
    border-top: 1px solid;
    border-color: ${({ theme }) => theme.colors.neutrals.ln30};
  }
`;

export const DisconnectionPropertyDetailsMeter: React.FC<Props> = ({
  meters,
  meterSerialOptional,
}) => {
  return (
    <Flex flexDirection="column">
      {meters.map((meter, index) => (
        <Box key={`propertyDetails.meterInfo.meters[${index}]`} mt={3} mb={3}>
          <Flex mb={3}>
            <Span
              display="inline-block"
              fontSize={4}
              lineHeight={4}
              fontWeight="medium"
            >
              Meter {index + 1}
            </Span>

            <IconPopupTip icon="help" ml={["auto", "auto", "auto", 3]}>
              {
                "The meter serial number e.g. 201234567 may be found on your electricity power bill or the electricity meter."
              }
            </IconPopupTip>
          </Flex>

          <MeterDividerLine />
          <Flex
            key={`propertyDetails.meterInfo.meters[${index}]`}
            flexDirection={["column", "column", "column", "row", "row"]}
            my={[4, 4, 4, 2, 2]}
          >
            <Flex
              flexDirection={"column"}
              flexGrow={0.5}
              flexBasis={0}
              data-testid={`propertyDetails.meterInfo.meters[${index}].location`}
            >
              <Field
                id={`propertyDetails.meterInfo.meters[${index}].location`}
                name={`propertyDetails.meterInfo.meters[${index}].location`}
                label="Location of meter"
                placeholder="e.g. outside right hand corner of building"
                mr={[0, 0, 0, 2, 2]}
                mt={2}
                mb={[3, 3, 3, 0, 0]}
                minWidth={["100%", "100%", "100%", 0, 0]}
                component={FormikInputText}
              />
              <ErrorMessage
                name={`propertyDetails.meterInfo.meters[${index}].location`}
                className="field-error"
                component={FormInputErrorMessage}
              />
            </Flex>

            <Flex
              flexDirection={"column"}
              flexGrow={0.5}
              flexBasis={0}
              data-testid={`propertyDetails.meterInfo.meters[${index}].serialNumber`}
            >
              <Field
                id={`propertyDetails.meterInfo.meters[${index}].serialNumber`}
                name={`propertyDetails.meterInfo.meters[${index}].serialNumber`}
                label="Meter serial number"
                placeholder="e.g. 12345678"
                optional={meterSerialOptional}
                mt={2}
                mb={[3, 3, 3, 0, 0]}
                minWidth={["100%", "100%", "100%", 0, 0]}
                component={FormikInputText}
              />
              <ErrorMessage
                name={`propertyDetails.meterInfo.meters[${index}].serialNumber`}
                className="field-error"
                component={FormInputErrorMessage}
              />
            </Flex>
          </Flex>
        </Box>
      ))}
    </Flex>
  );
};
